import React from 'react';
import { Waves } from '../components/wave-background.tsx';

const navLinks = [
  { label: 'Works', href: 'https://ecaterina.app/works' },
  { label: 'Contact', href: 'mailto:ecaterinamnl@gmail.com' },
];
const socialLinks = [{ label: 'LI', href: 'https://ro.linkedin.com/in/ecaterina-manole-72060b358' }];
const capabilities = [
  'Front-end development',
  'Back-end development',
  'API development',
  'Machine Learning',
  'UI/UX',
  'Wordpress',
];

const styles = `
  .quentin-page {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    background: #060606;
    color: #ffffff;
    font-family: 'Avenir Next', 'Helvetica Neue', 'Segoe UI', sans-serif;
  }

  .quentin-page * {
    box-sizing: border-box;
  }

  .quentin-surface {
    position: relative;
    min-height: 100vh;
    max-width: 1600px;
    margin: 0 auto;
    padding: clamp(1rem, 1.1vw, 1.5rem);
    display: flex;
    flex-direction: column;
    isolation: isolate;
  }

  .quentin-header,
  .quentin-meta,
  .quentin-hero,
  .quentin-version {
    position: relative;
    z-index: 3;
  }

  .quentin-header {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 1rem;
    font-size: clamp(0.76rem, 0.82vw, 0.94rem);
    line-height: 1;
    letter-spacing: -0.03em;
  }

  .quentin-brand {
    font-weight: 600;
  }

  .quentin-nav,
  .quentin-socials {
    display: flex;
    align-items: center;
    gap: clamp(0.8rem, 1.2vw, 1.25rem);
  }

  .quentin-nav {
    justify-content: center;
  }

  .quentin-socials {
    justify-content: flex-end;
    font-size: clamp(0.68rem, 0.72vw, 0.82rem);
    letter-spacing: -0.02em;
  }

  .quentin-link {
    color: inherit;
    text-decoration: none;
  }

  .quentin-link:hover,
  .quentin-link:focus-visible {
    opacity: 0.7;
  }

  .quentin-meta {
    margin-top: clamp(3.5rem, 11vh, 7rem);
    display: grid;
    grid-template-columns: 0.8fr 1.15fr 1.2fr 0.7fr;
    gap: clamp(0.8rem, 2vw, 2rem);
    align-items: start;
    font-size: clamp(0.92rem, 1vw, 1.05rem);
    line-height: 1.16;
    letter-spacing: -0.035em;
  }

  .quentin-meta p,
  .quentin-meta ul {
    margin: 0;
  }

  .quentin-meta ul {
    padding: 0;
    list-style: none;
  }

  .quentin-meta-right {
    text-align: right;
  }

  .quentin-hero {
    margin-top: auto;
    padding-top: clamp(2rem, 5vh, 4rem);
    width: 100%;
  }

  .quentin-link-hero {
    display: inline-block;
    text-decoration: none;
  }

  .quentin-link-hero:hover,
  .quentin-link-hero:focus-visible {
    opacity: 0.8;
  }

  .quentin-line {
    margin: 0;
    font-family: 'Arial Black', 'Avenir Next Condensed', 'Helvetica Neue', sans-serif;
    font-size: clamp(3.4rem, 8.2vw, 8.6rem);
    line-height: 0.9;
    letter-spacing: -0.055em;
    font-weight: 900;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .quentin-line-split {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  }

  .quentin-line-two {
    padding-left: clamp(8rem, 32vw, 30rem);
  }

  .quentin-line-three {
    padding-left: clamp(2rem, 8vw, 8rem);
  }

  .quentin-line-four {
    padding-left: clamp(4rem, 14vw, 14rem);
    color: #c94848;
  }

  .quentin-version {
    margin-top: auto;
    padding-top: 1rem;
    font-size: clamp(0.75rem, 0.9vw, 0.9rem);
    font-weight: 600;
    letter-spacing: -0.04em;
  }

  @media (max-width: 1440px) {
    .quentin-surface {
      padding: 1rem;
    }

    .quentin-meta {
      margin-top: clamp(3rem, 9vh, 5.5rem);
      gap: clamp(0.75rem, 1.5vw, 1.5rem);
      font-size: clamp(0.88rem, 0.95vw, 1rem);
    }

    .quentin-line {
      font-size: clamp(3rem, 7.6vw, 7.6rem);
      line-height: 0.9;
    }

    .quentin-line-two {
      padding-left: clamp(6rem, 24vw, 20rem);
    }

    .quentin-line-three {
      padding-left: clamp(1.5rem, 6vw, 5rem);
    }

    .quentin-line-four {
      padding-left: clamp(3rem, 10vw, 9rem);
    }
  }

  @media (max-width: 1200px) {
    .quentin-meta {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      row-gap: 1.4rem;
    }

    .quentin-line {
      white-space: normal;
      font-size: clamp(3rem, 9vw, 6.6rem);
      line-height: 0.92;
    }

    .quentin-line-split {
      display: block;
    }

    .quentin-line-two,
    .quentin-line-three,
    .quentin-line-four {
      padding-left: 0;
    }

    .quentin-line-four {
      margin-top: 0.2rem;
    }
  }

  @media (max-width: 820px) {
    .quentin-surface {
      padding: 0.9rem;
    }

    .quentin-line-split {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }

  .quentin-line-split span {
    display: block;
    width: 100%;
  }

    .quentin-header {
      grid-template-columns: 1fr;
      justify-items: start;
      gap: 0.85rem;
      font-size: 0.82rem;
    }

    .quentin-nav,
    .quentin-socials {
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 0.8rem;
    }

    .quentin-meta {
      grid-template-columns: 1fr;
      margin-top: 2.5rem;
      gap: 1rem;
      max-width: 26rem;
      font-size: 0.95rem;
    }

    .quentin-meta-right {
      text-align: left;
    }

    .quentin-hero {
      margin-top: 3rem;
      padding-top: 0;
    }

    .quentin-line {
      font-size: clamp(2.6rem, 13vw, 4.8rem);
      line-height: 0.92;
      letter-spacing: -0.045em;
      white-space: normal;
      word-break: break-word;
    }

    .quentin-line + .quentin-line {
      margin-top: 0.15rem;
    }

    .quentin-line-split {
      gap: 0.2rem;
    }
  }

  @media (max-width: 560px) {
    .quentin-surface {
      padding: 0.75rem;
    }

    .quentin-line-split {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }

  .quentin-line-split span {
    display: block;
    width: 100%;
  }

    .quentin-header {
      gap: 0.7rem;
      font-size: 0.78rem;
    }

    .quentin-meta {
      margin-top: 2rem;
      font-size: 0.9rem;
      line-height: 1.2;
    }

    .quentin-line {
      font-size: clamp(2.15rem, 14vw, 3.8rem);
      line-height: 0.95;
      letter-spacing: -0.04em;
    }

    .quentin-line-four {
      margin-top: 0.1rem;
    }
  }
`;

const QuentinHocde = () => {
  return (
    <>
      <style>{styles}</style>
      <main className="quentin-page">
        <div className="quentin-surface">
          <Waves
            strokeColor="#8a8a8a"
            backgroundColor="#000000"
            pointerSize={0.5}
          />

          <header className="quentin-header">
            <div className="quentin-brand"></div>

            <nav className="quentin-nav" aria-label="Primary">
              {navLinks.map(({ label, href }) => (
                <a
                  key={label}
                  className="quentin-link"
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {label}
                </a>
              ))}
            </nav>

            <div className="quentin-socials" aria-label="Social links">
              {socialLinks.map(({ label, href }) => (
                <a
                  key={label}
                  className="quentin-link"
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {label}
                </a>
              ))}
            </div>
          </header>

          <section className="quentin-meta" aria-label="Introduction">
            <p></p>

            <p>
              Software Developer.
              <br />
              I build websites with
              <br />
              motion, subtle details and fun
              <br />
              interactions.
            </p>

            <ul>
              {capabilities.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            <p className="quentin-meta-right">
              Based in
              <br />
              Romania
            </p>
          </section>

          <section className="quentin-hero" aria-label="Hero">
  <h1 className="quentin-line quentin-line-split">
    <span>ECATERINA</span>
    <span>MANOLE</span>
  </h1>

  <div className="quentin-hero-stack">
    <p className="quentin-line quentin-line-two">VIEW</p>
    <p className="quentin-line quentin-line-three">MY WORKS</p>
    <a
      className="quentin-line quentin-line-four quentin-link-hero"
      href="/works"
    >
      HERE
    </a>
  </div>
</section>
        </div>
      </main>
    </>
  );
};

export default QuentinHocde;
